import {Component, Input, OnInit} from '@angular/core';
import {PublicationModel} from '../../../../models/publication.model';

@Component({
  selector: 'app-publication-information-summary-part',
  templateUrl: './publication-information-summary-part.component.html',
  styleUrls: ['./publication-information-summary-part.component.scss']
})
export class PublicationInformationSummaryPartComponent implements OnInit {
    @Input() publication: PublicationModel = new PublicationModel();
  constructor() { }

  ngOnInit() {
  }
 }



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/publication-registration/base-summary-form-part/publication-information-summary-part/publication-information-summary-part.component.ts